import React from 'react';
import { TextWithAnnotationDraft } from '../../ui/annotations/draft/component';
var TextWrapper = function TextWrapper(props) {
  var startPos = props.startPos,
    endPos = props.endPos;
  var children = props.children;
  if (!children) {
    return null;
  }
  return /*#__PURE__*/React.createElement(TextWithAnnotationDraft, {
    startPos: startPos,
    endPos: endPos,
    textHighlighter: props.textHighlighter,
    marks: props.marks
  }, children);
};
export default TextWrapper;